import vero from './vero/actions'
import gifts from './gifts/actions'
import cookies from './cookies/actions'
import twitter from './twitter/actions'
import google from './google/actions'
import newsLetter from './newsLetter/actions'
import vindiciaUrl from './vindiciaUrl/actions'
import localStorage from './localStorage/actions'
import notifications from './notifications/actions'


export default {
  vero,
  gifts,
  cookies,
  twitter,
  google,
  newsLetter,
  vindiciaUrl,
  localStorage,
  notifications,
}
